
import Fly from 'flyio/dist/npm/fly'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'
import IndexAdvantages from '@/components/IndexAdvantages'

export default {
components: {
XButton,
Box,
Flexbox,
FlexboxItem,
IndexHeader,
IndexSidebar,
IndexFooter,
IndexAdvantages,
Swiper,
SwiperItem
},
data () {
return {
tabIndex: '0',
tabIndex1: '0',
resourceTabIndex: '0',
resourceTabIndex1: '0',
resourceFashion: [],
resourceFood: [],
resourceBeauty: [],
resourceTypical: [
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource01.png',
resourceTitle: '免费纸巾机',
resourceText: '扫码免费，领取纸巾'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource02.png',
resourceTitle: '免费照片机',
resourceText: '扫码免费，打印照片'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource03.png',
resourceTitle: '移动支付',
resourceText: '线下高频制作，无意识流量导入'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource04.png',
resourceTitle: '免费纸巾机',
resourceText: '扫码测体脂,9项数据让你更了解自己'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource05.png',
resourceTitle: 'WIFI',
resourceText: '选择商超、学校、医院、景区、连锁、车站等'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource06.png',
resourceTitle: '粉丝池',
resourceText: '根据公众号与用户使用习惯设定'
}
]
}
},
methods: {
changeTabContent (index) {
this.tabIndex = index
},
changeResourceTab (index) {
this.resourceTabIndex = index
},
changeResourceTab1 (index) {
this.resourceTabIndex1 = index
},
handleDoubleData () {
let fly = new Fly() 

fly.request('https://www.xinmeibao.com//api/web_live', {}, {
method: 'get'
}).then(resp => {
var transferData = JSON.parse(resp.data)
if (transferData.success) {
this.resourceFashion = transferData.message.fashion
this.resourceFood = transferData.message.mother
this.resourceBeauty = transferData.message.beauty
}
}).catch((e) => console.log('error', e))
},

changeTab (index) {
this.tabIndex1 = index
}
},
filters: {
formatNumInTenThousand: function (value) {
const num = parseInt(value)
const num2 = num / 10000
if (num2 >= 1) {
return Math.round(num2 * 100) / 100 + '万'
} else {
return num
}
}
},
mounted () {
this.handleDoubleData()
}
}



// WEBPACK FOOTER //
// ./src/pages/promotionWxzf/index.vue